export default __webpack_public_path__ + "static/media/visual-studio.f4e2417d.svg";